import { Enum } from 'enumify-mod';

class Sexes extends Enum {
	static MEN;
	static WOMEN;
	static UNISEX;
	static KIDS;
}

Sexes.initEnum({
	MEN: 'Men',
	WOMEN: 'Women',
	UNISEX: 'Unisex',
	KIDS: 'Kids'
});

/**
 * @return {SelectOption[]}
 */
Sexes.toOptions = () => [
	{ value: Sexes.MEN.valueOf(), label: 'Men', selected: false },
	{ value: Sexes.WOMEN.valueOf(), label: 'Women', selected: false },
	{ value: Sexes.UNISEX.valueOf(), label: 'Unisex', selected: false },
	{ value: Sexes.KIDS.valueOf(), label: 'Kids', selected: false }
];

export default Sexes;



// WEBPACK FOOTER //
// ./enums/Sexes.js